import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function formatSize(bytes) {
  if (!bytes) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
}

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/api/stats').then(r => r.ok ? r.json() : null).then(d => setStats(d && d.total_documents != null ? d : null)).catch(() => {});
  }, []);

  const cards = stats ? [
    { label: 'Dokumente', value: stats.total_documents || 0, icon: '\uD83D\uDCDA', color: 'var(--accent-docbrain, #bb9af7)' },
    { label: 'Speicher', value: formatSize(stats.total_size_bytes), icon: '\uD83D\uDCBE', color: '#7aa2f7' },
    { label: 'Verarbeitet', value: stats.by_status?.ready || 0, icon: '\u2705', color: '#9ece6a' },
    { label: 'Chunks', value: stats.total_chunks || 0, icon: '\uD83E\uDDE9', color: '#e0af68' },
  ] : [];

  return (
    <div style={{ padding: 'var(--gap-lg)', maxWidth: 900 }}>
      <h2 style={{ color: 'var(--text-primary)', marginBottom: 'var(--gap-lg)', fontSize: 'var(--font-size-xl)', fontWeight: 600 }}>Dashboard</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 'var(--gap-md)' }}>
        {cards.map(c => (
          <div key={c.label} style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 'var(--border-radius-lg)', padding: 'var(--gap-lg)', textAlign: 'center' }}>
            <div style={{ fontSize: 28, marginBottom: 8 }}>{c.icon}</div>
            <div style={{ fontSize: 'var(--font-size-xl)', fontWeight: 700, color: c.color }}>{c.value}</div>
            <div style={{ fontSize: 'var(--font-size-sm)', color: 'var(--text-secondary)', marginTop: 4 }}>{c.label}</div>
          </div>
        ))}
      </div>

      <div style={{ marginTop: 'var(--gap-xl)', display: 'flex', gap: 'var(--gap-md)', flexWrap: 'wrap' }}>
        {[
          { label: 'Upload', path: '/upload', icon: '\uD83D\uDCE4' },
          { label: 'Bibliothek', path: '/library', icon: '\uD83D\uDCDA' },
          { label: 'KI-Analyse', path: '/analyze', icon: '\uD83E\uDDE0' },
          { label: 'Chat', path: '/chat', icon: '\uD83D\uDCAC' },
          { label: 'Suche', path: '/search', icon: '\uD83D\uDD0D' },
          { label: 'Generator', path: '/generate', icon: '\u2728' },
        ].map(a => (
          <button key={a.path} onClick={() => navigate(a.path)} style={{ background: 'var(--bg-tertiary)', border: '1px solid var(--border)', borderRadius: 'var(--border-radius)', padding: '12px 20px', color: 'var(--text-primary)', cursor: 'pointer', fontSize: 'var(--font-size-base)', display: 'flex', alignItems: 'center', gap: 8, transition: 'var(--transition-fast)' }}>
            <span>{a.icon}</span> {a.label}
          </button>
        ))}
      </div>
    </div>
  );
}
